import { NgModule } from '@angular/core';
import { CustomerComponent } from '@rensa/modules/customer/customer.component';
import { CustomerRoutingModule } from '@rensa/modules/customer/customer-routing.module';
import { ListItemComponent } from './components/shared/list-item/list-item.component';
import { ListItemDetailComponent } from './components/shared/list-item/list-item-detail.component';
import { SharedModule } from '@rensa/shared/shared.module';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { MenuComponent } from './components/menu/menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { EventTableComponent } from './components/event-table/event-table.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { UnregisterComponent } from './components/unregister/unregister.component';
import { KenniscafeComponent } from './components/kenniscafe/kenniscafe.component';
import { TrainingenComponent } from './components/trainingen/trainingen.component';


@NgModule({
  declarations: [
    CustomerComponent,
    ListItemComponent,
    ListItemDetailComponent,
    LandingPageComponent,
    MenuComponent,
    FooterComponent,
    EventTableComponent,
    RegistrationComponent,
    UnregisterComponent,
    KenniscafeComponent,
    TrainingenComponent
  ],
  imports: [CustomerRoutingModule, SharedModule]
})
export class CustomerModule {
}
